<div *ngIf="isInitialized">
  <div [class.wrapper]="showTip">
    <div class="modal-header">
      <h4 class="modal-title pull-left">
        {{ 'CHECK_OUT_EXPLANATION_1' | translate }}
      </h4>
      <button id="closePickUpActionModal" type="button" class="close pull-right" aria-label="Close" (click)="close()">
        <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="luggage-image" *ngIf="luggageImage" (click)="showLuggageImage($event)">
        <img [imageName]="luggageImage" imageSize="medium" lhImage />
        <div class="enlarge-cta">
          <div class="icon-container">
            <i class="icon-enlarge"></i>
          </div>
        </div>
      </div>

      <!-- Add tips -->
      <div class="tip-container" *ngIf="showTip">
        <h5>{{ 'TIP_THE_STAFF' | translate }}</h5>

        <div class="tip-options">
          <button
            *ngFor="let tipOption of tipOptions"
            (click)="setTipAmount(tipOption.amount)"
            class="btn btn-default btn-lg"
            [class.active]="tip === tipOption.amount && !isCustomTipVisible"
            [disabled]="isLoading"
          >
            <span>{{ tipOption.label }}</span>
          </button>
        </div>

        <button
          class="btn btn-default btn-block btn-lg btn-custom-tip"
          [class.active]="isCustomTipVisible"
          (click)="toggleCustomTip()"
          [disabled]="isLoading"
          *ngIf="!isCustomTipVisible"
        >
          {{ 'OTHER_TIP_AMOUNT' | translate }}
        </button>

        <div [hidden]="!isCustomTipVisible" class="custom-tip">
          <span class="currency-symbol">{{ currencySymbol }}</span>
          <input
            id="customTip"
            name="customTip"
            #customTip="ngModel"
            class="form-control tip-input"
            type="tel"
            pattern="^\d+\.{0,1}\d{0,2}$"
            [(ngModel)]="tip"
            [placeholder]="'Tip amount' | translate"
            [value]="customTipValue"
            #customTipInput
          />
        </div>

        <div class="alerts" *ngIf="!isLoading">
          <div *ngIf="isCustomTipInvalid" class="alert alert-danger">
            {{ 'TIP_AMOUNT_INVALID' | translate }}
          </div>
          <div *ngIf="isTipTooLarge" class="alert alert-danger">
            {{ 'TIP_NO_MORE_THAN_X' | translate }} {{ maxTipFormatted }}
          </div>
          <div *ngIf="isMissingTipSelection" class="alert alert-danger">
            {{ 'MISSING_TIP_CHOICE_ALERT' | translate }}
          </div>
        </div>

        <div class="tip-note">
          {{ 'PARTNERS_RECEIVE_ALL_TIPS' | translate }}
        </div>
      </div>

      @if (shop && shop.isSelfService) {
        <!-- Show divider if there is a luggage image or if the tip is shown -->
        <hr *ngIf="showTip || !!luggageImage" />

        <!-- Self-service storage room access info -->
        <lh-shared-feature-bookings-storage-room-access-info
          [booking]="booking"
          [storageLocation]="shop"
          [size]="'medium'"
        ></lh-shared-feature-bookings-storage-room-access-info>
      }
    </div>

    <div class="modal-footer">
      <!-- Storage timer -->
      <div class="timer-wrapper" *ngIf="isStorageTimerEnabled">
        <lh-storage-timer
          [booking]="booking"
          [isCheckInSession]="false"
          [compactMode]="true"
          [largeDigits]="true"
        ></lh-storage-timer>
      </div>

      <lh-shared-ui-confirm-button
        id="confirmCheckOut"
        [slideCallToAction]="'SLIDE_TO_CONFIRM_PICKUP' | translate"
        [clickCallToAction]="'CONFIRM_PICKUP' | translate"
        (confirm)="checkOut()"
        [mode]="'success'"
        [disabled]="!canStopTimer"
        [isLoading]="isLoading"
        *ngIf="isSlideToConfirmEnabled"
        #confirmButton
      >
      </lh-shared-ui-confirm-button>
    </div>
  </div>
</div>
